import { render } from "./BomValidationsResultsItem.vue?vue&type=template&id=23ead004&scoped=true"
import script from "./BomValidationsResultsItem.vue?vue&type=script&lang=js"
export * from "./BomValidationsResultsItem.vue?vue&type=script&lang=js"

import "./BomValidationsResultsItem.vue?vue&type=style&index=0&id=23ead004&lang=scss&scoped=true"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23ead004"]])

export default __exports__